import { Component, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";
import ConsentPage from "@/components/ConsentPage";
import { studentConsentCollection } from "@/firebase";

@Component
export default class Student extends Vue {
  content: any = [
    [
      "Who we are?",
      `We are researchers from the University of Toronto, and we have created a computer-based research project to help students in Grades 3-6 improve their reading, writing, and learning skills. We would like to invite you to be a part of this research.`
    ],
    [
      "Why are we doing this study?",
      `We want to show how technology-enhanced assessments support teaching and learning in classrooms. <p> The study will be included as part of your school activities and will continue for the rest of the term.`
    ],
    [
      "What would I have to do?",
      `We will ask you to complete three assessments:<p> <p>
      ▪ The first assessment, BALLI, has four tasks with questions that will help us understand how you feel about reading and writing. You will do these tasks in class with your teacher and peers.<p>
      ▪ The second assessment, BALA, gives you the opportunity to do several reading and writing tasks. You will also do these tasks in class with your teacher and peers.<p>
      ▪ The third assessment, Talk2Me Jr., has six fun activities that help us understand the ways you use language and solve puzzles. You will do these activities with us individually.<p>`
    ],
    [
      "Who will see my information?",
      `We will not share your information with anyone other than your teachers and the research team. At the end we will provide feedback on how you did. `
    ],
    [
      "Consequences",
      `This study might help you understand and improve the way you learn. It will also give us  information that can help us improve our assessments for other students, including those with special needs. If any of the tasks are challenging for you, you can stop or take a break if you get tired. If you feel upset or distressed let us or your teacher know. We will stop the task immediately and get help for you.<p> <p> We are inviting you to be a part of this study, but it is up to you to decide if you want to be in the study. You can also stop participating at any time and no one will be angry or upset. If you want to stop just tell us, or your teacher, or your parents. <p> <p> You can talk to any of the researchers, your teacher, or your parents about questions you may have.`
    ]
  ];

  formModel: any = [
    {
      key: "label",
      label:
        "If you agree to participate in the study, please check the following buttons:",
      type: "label"
    },
    {
      key: "readInfo", // DO NOT CHANGE THIS
      label: "I have read the above information.",
      type: "checkbox"
    },
    {
      key: "consent", // DO NOT CHANGE THIS
      label: "I agree to participate.",
      type: "radio",
      props: [
        { key: 1, label: "Agree", value: true },
        { key: 2, label: "Disagree", value: false }
      ]
    }
  ];

  render(h: CreateElement) {
    return (
      <ConsentPage
        buttonLabel={"Next"}
        form-model={this.formModel}
        content={this.content}
        title="Student Assent Form"
        type="student"
        showNotification={true}
        collection={studentConsentCollection}
        routing="/signup"
        callbackfn={() => {
          this.$router.push({ name: "signup" });
        }}
      >
        <p slot="description">
          Hello!
          <br />
          <br />
          We invite you to participate in a research project to develop a new
          literacy assessment for students in Grades 3 to 6. This assessment,
          called BalanceAI (Blended Assessment of Literacy and Numeracy in
          Computerized Environments), can help you improve your literacy and
          learning skills with tasks that are fun and engaging.
        </p>
      </ConsentPage>
    );
  }
}

const component = Student;
